var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","viewBox":"0 0 100 100"}},[_c('path',{attrs:{"d":"M50,0C22.4,0,0,22.4,0,50s22.4,50,50,50s50-22.4,50-50S77.6,0,50,0z M73.3,54.8L37.8,75.2c-3.2,1.8-7.2-0.5-7.2-4.2V29 c0-3.7,4-6,7.2-4.2l35.5,21.6C76.6,48.2,76.6,53,73.3,54.8z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }